export default __webpack_public_path__ + "static/media/pair-explorer.451a70dd.svg";